import { ReactNode, useContext } from 'react'
import { TableContext, TableContextType } from '../table.types'
import styled from 'styled-components'

export const useTableContext = () => {
  const context = useContext(TableContext)
  if (!context) {
    throw new Error('useTableContext must be used within a TableProvider')
  }
  return context
}

const TableWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.sizes.xs};
    border-radius: 8px;
    overflow: hidden;
    padding: ${theme.sizes.s};
    background-color: white;
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    text-align: left;
  `}
`

const TableTitle = styled.h3`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  margin: 0 8px;
  line-height: 32px;
`

export const TableProvider = ({
  children,
  columns,
  title,
  totalResults,
  isLoading,
  illustration,
  emptyTableTitle,
  emptyTableDescription,
  emptyTableButton,
  emptyTableButtonShape,
  tableHeadTestId,
  handleRequestSort,
  sortDirection,
  sortByColumn,
  disableHorizontalScroll,
  className,
  dataTestId,
}: {
  children: ReactNode
  className?: string
  dataTestId?: string
} & TableContextType) => {
  const contextValue = {
    columns,
    title,
    totalResults,
    isLoading,
    illustration,
    emptyTableTitle,
    emptyTableDescription,
    emptyTableButton,
    emptyTableButtonShape,
    tableHeadTestId,
    handleRequestSort,
    sortDirection,
    sortByColumn,
    disableHorizontalScroll,
  }

  return (
    <TableContext.Provider value={contextValue}>
      <TableWrapper className={className} data-testid={dataTestId}>
        {title && <TableTitle>{title}</TableTitle>}
        {children}
      </TableWrapper>
    </TableContext.Provider>
  )
}
